// extracted by mini-css-extract-plugin
module.exports = {"skipButton":"_3kFCwD"};